import { Board, getBoardType } from "@sportactics/board-editing";

import { BoardModel } from "./board-model";
import { convertDrawingToModel } from "./convert-drawing-model";
import { convertLineToModel } from "./convert-line-model";
import { convertTextToModel } from "./convert-text-model";
import { convertTokenToModel } from "./convert-token-model";

export function convertBoardToModel(board: Board): BoardModel {
  return {
    type: getBoardType(board),
    size: board.size,
    isEmpty: board.isEmpty,
    tokens: board.tokens.map(convertTokenToModel),
    drawings: board.drawings.map(convertDrawingToModel),
    lines: board.lines.map(convertLineToModel),
    texts: board.texts.map(convertTextToModel),
  };
}
